var render = function render(){var _vm=this,_c=_vm._self._c;return _c('main',{attrs:{"id":"home"}},[_c('BannerGaleria'),_c('Video'),_c('DarkText'),_c('Investments'),(_vm.$store.state.asideVideo != null)?_c('AsideVideo'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }